import script from "./InstructionTradeEvoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionTradeEvoPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionTradeEvoPage.vue?vue&type=style&index=0&id=07a4f208&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a4f208"]])

export default __exports__